/* Okno po dodaniu do koszyka: potwierdzenie + produkty tego samego zapachu.
   Rekomendacja jest oparta na tagu zapachu, a nie na historii zamowien -
   sklep jej jeszcze nie ma, a "inni kupili rowniez" bez danych byloby nieprawda. */
(() => {
  const modal = document.getElementById('CiroaAddModal');
  if (!modal) return;

  const box     = modal.querySelector('.ciroa-am__box');
  const dodany  = modal.querySelector('[data-am-added]');
  const reko    = modal.querySelector('[data-am-reko]');
  const lista   = modal.querySelector('[data-am-lista]');
  const blad    = modal.querySelector('.ciroa-am__blad');
  const MAKS    = 3;
  let ostatniFokus = null;
  let wlasneDodanie = false;   // dodanie z tego okna nie ma go otwierac ponownie

  const esc = (s) => String(s ?? '').replace(/[&<>"']/g,
    (c) => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));
  const cena = (grosze) => (grosze / 100).toLocaleString('pl-PL',
    { style:'currency', currency:'PLN' });
  /* /search/suggest.json oddaje cene jako goly tekst "32.99" - formatujemy sami */
  const cenaZTekstu = (tekst) => {
    const liczba = parseFloat(String(tekst).replace(/[^\d.,]/g, '').replace(',', '.'));
    return Number.isFinite(liczba) ? cena(Math.round(liczba * 100)) : String(tekst);
  };

  /* --- otwieranie i zamykanie --- */
  const otworz = () => {
    ostatniFokus = document.activeElement;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    (box.querySelector('.ciroa-am__x') || box).focus();
    document.addEventListener('keydown', naKlawisz);
  };
  const zamknij = () => {
    modal.hidden = true;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', naKlawisz);
    if (ostatniFokus && document.contains(ostatniFokus)) ostatniFokus.focus();
  };
  const naKlawisz = (e) => {
    if (e.key === 'Escape') { zamknij(); return; }
    if (e.key !== 'Tab') return;
    // pulapka fokusu - z okna modalnego nie wychodzimy tabulatorem
    const f = [...box.querySelectorAll('a[href], button, [tabindex]:not([tabindex="-1"])')]
      .filter((el) => !el.disabled && el.offsetParent !== null);
    if (!f.length) return;
    const pierwszy = f[0], ostatni = f[f.length - 1];
    if (e.shiftKey && document.activeElement === pierwszy) { e.preventDefault(); ostatni.focus(); }
    else if (!e.shiftKey && document.activeElement === ostatni) { e.preventDefault(); pierwszy.focus(); }
  };
  modal.addEventListener('click', (e) => { if (e.target.closest('[data-am-close]')) zamknij(); });

  /* --- dane --- */
  const wZapachu = (tagi = []) => tagi.find((t) => / and /i.test(t)) || null;

  const pobierzPropozycje = async (produkt, wKoszyku) => {
    const zapach = wZapachu(produkt.tags);
    if (!zapach) return [];
    const url = `/search/suggest.json?q=${encodeURIComponent(zapach)}`
              + `&resources[type]=product&resources[limit]=10`;
    const dane = await (await fetch(url)).json();
    return (dane.resources?.results?.products || [])
      .filter((p) => p.handle !== produkt.handle && !wKoszyku.has(p.handle))
      .slice(0, MAKS);
  };

  /* CDN Shopify skaluje w locie - bez tego ciagnelibysmy oryginal 2500x2500
     dla kwadratu 52 px */
  const miniatura = (url, px = 160) =>
    url ? url + (url.includes('?') ? '&' : '?') + 'width=' + px : '';

  const kartaProduktu = (p) => `
    <li class="ciroa-am__item">
      <a class="ciroa-am__media" href="${esc(p.url)}" tabindex="-1" aria-hidden="true">
        ${p.featured_image?.url ? `<img src="${esc(miniatura(p.featured_image.url))}" alt="" width="52" height="52" loading="lazy">` : ''}
      </a>
      <div class="ciroa-am__body">
        <a class="ciroa-am__name" href="${esc(p.url)}">${esc(p.title)}</a>
        <span class="ciroa-am__price">${esc(cenaZTekstu(p.price))}</span>
      </div>
      <button type="button" class="ciroa-am__add" data-handle="${esc(p.handle)}"
        aria-label="Dodaj do koszyka: ${esc(p.title)}">Dodaj</button>
    </li>`;

  /* --- reakcja na dodanie --- */
  const pokazPo = async (handle) => {
    try {
      blad.hidden = true;
      const produkt = await (await fetch(`/products/${handle}.js`)).json();
      dodany.innerHTML = `
        ${produkt.featured_image ? `<img src="${esc(miniatura(produkt.featured_image, 200))}" alt="" width="64" height="64">` : ''}
        <div>
          <span class="ciroa-am__dodany-nazwa">${esc(produkt.title)}</span>
          <span class="ciroa-am__dodany-cena">${cena(produkt.price)}</span>
        </div>`;

      const koszyk = await (await fetch('/cart.js')).json();
      const wKoszyku = new Set(koszyk.items.map((i) => i.handle));
      const propozycje = await pobierzPropozycje(produkt, wKoszyku);

      if (propozycje.length) {
        lista.innerHTML = propozycje.map(kartaProduktu).join('');
        reko.hidden = false;
      } else {
        reko.hidden = true;
      }
      otworz();
    } catch (e) {
      /* nawet gdy rekomendacje zawiodą, klient powinien dostać potwierdzenie */
      reko.hidden = true;
      otworz();
    }
  };

  /* dodawanie z samego okna */
  lista.addEventListener('click', async (e) => {
    const btn = e.target.closest('.ciroa-am__add');
    if (!btn || btn.disabled) return;
    const etykieta = btn.textContent;
    btn.disabled = true; btn.textContent = 'Dodaję…';
    wlasneDodanie = true;
    try {
      const p = await (await fetch(`/products/${btn.dataset.handle}.js`)).json();
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: p.variants[0].id, quantity: 1 }] }),
      });
      if (!r.ok) throw new Error();
      btn.textContent = 'Dodano';
      btn.closest('.ciroa-am__item')?.classList.add('ciroa-am__item--dodany');
      document.querySelectorAll('#cart-icon-bubble').forEach(async (el) => {
        const html = await (await fetch('/?section_id=cart-icon-bubble')).text();
        el.innerHTML = new DOMParser().parseFromString(html, 'text/html')
          .querySelector('#cart-icon-bubble')?.innerHTML ?? el.innerHTML;
      });
    } catch (err) {
      btn.disabled = false; btn.textContent = etykieta;
      blad.textContent = 'Nie udało się dodać produktu. Spróbuj ponownie.';
      blad.hidden = false;
    } finally {
      wlasneDodanie = false;
    }
  });

  /* --- przechwycenie dodania do koszyka --- */
  const oryginalnyFetch = window.fetch;
  window.fetch = async function (...args) {
    const odp = await oryginalnyFetch.apply(this, args);
    try {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url ?? '';
      if (/\/cart\/add/.test(url) && odp.ok && !wlasneDodanie) {
        const dane = await odp.clone().json();
        const handle = dane.items?.[0]?.handle ?? dane.handle;
        if (handle) {
          // szuflada Dawn otwiera się sama po dodaniu - zamykamy ją,
          // żeby nie nakładała się na okno
          setTimeout(() => {
            document.querySelector('cart-drawer')?.close?.();
            pokazPo(handle);
          }, 60);
        }
      }
    } catch (e) { /* przechwycenie nie może psuć dodawania */ }
    return odp;
  };
})();
